import {Typography} from 'components/Typography';
import style from './style.module.scss';
import {ReactElement} from 'react';
import cs from 'classnames';

interface IProductCharacteristicsMoreButtonProps {
    text: string;
    icon?: ReactElement;
    onClick: () => void;
    className?: string;
}

export const ProductCharacteristicsMoreButton = ({
    text,
    icon,
    onClick,
    className,
}: IProductCharacteristicsMoreButtonProps) => {
    return (
        <Typography
            className={cs(style.showInfo, className)}
            color={'gray100'}
            data-skeleton-item={true}
            element={'div'}
            onClick={onClick}
            variant={'label-16-m'}
        >
            <span>{text}</span>
            {icon}
        </Typography>
    );
};
